module.exports = __webpack_public_path__ + "img/logo-kakao-vx.47246bfc.svg";